import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from 'components/Button';
import Paper from 'components/Paper';
import Input from 'components/Input';
import ResendWidget from 'components/ResendWidget';

const StyledVerifyView = styled.div`
  ${Button} {
    margin-top: ${({ theme }) => theme.spacing * 2}px;
  }

  ${Paper} {
  margin-bottom: ${({ theme }) => theme.spacing * 4}px;
  }
`;

const VerifyView = (
  {
    email, className, error, onSubmit, onChange, onResendClick,
  },
) => {
  const classes = ['VerifyView'];
  if (className) {
    classes.push(className);
  }

  const [code, setCode] = useState('');
  const [forceDisable, setForceDisable] = useState(false);

  useEffect(() => {
    if (error) {
      setForceDisable(true);
    }
  }, [error]);

  const handleChange = (e) => {
    setCode(e.target.value);
    setForceDisable(false);
    if (onChange) onChange();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setForceDisable(true);
    onSubmit(code);
  };

  return (
    <StyledVerifyView className={classes.join(' ')}>
      <h1>Thanks, please check your email</h1>
      <p>
        We&apos;ve sent a verification code by email to&nbsp;
        <strong>
          {email}
        </strong>
        . Enter it below to validate your account
      </p>
      <Paper>
        <form onSubmit={handleSubmit} noValidate>
          <Input
            label="Code"
            type="text"
            placeholder="Enter the email code"
            value={code}
            error={error}
            onChange={handleChange}
          />
          <Button
            type="submit"
            disabled={!code || forceDisable}
            dataLayer={{ action: 'Login Portal', label: 'Email Address Verified' }}
            fullWidth
          >
            Continue
          </Button>
        </form>
      </Paper>
      <ResendWidget
        onResendClick={onResendClick}
      />
    </StyledVerifyView>
  );
};

VerifyView.displayName = 'VerifyView';

VerifyView.propTypes = {
  email: PropTypes.string.isRequired,
  className: PropTypes.string,
  error: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onResendClick: PropTypes.func.isRequired,
  onChange: PropTypes.func,
};

VerifyView.defaultProps = {
  className: null,
  error: null,
  onChange: null,
};

export default VerifyView;
